function setup_site() {

  const setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const dismissBtn = document.getElementById("dismiss-live-notification");
  const liveNotification = document.getElementById("live-notification");

  if (dismissBtn) {
    if (getCookie('live-notification') !== "") {
      if (liveNotification) liveNotification.style.display = 'none';
    } else {
      if (liveNotification) liveNotification.style.display = 'block';
    }

    dismissBtn.addEventListener('click', () => {
      console.log("asass");  
      setCookie('live-notification', 'true', 7)
    });
  }

  const iframe = document.getElementById("modalVideo");
  if (iframe) {
    var player = new Vimeo.Player(iframe);

    // Bind defensively via jQuery if loaded
    if (window.jQuery) {
      window.jQuery("#videoPlayerModal").on("hide.bs.modal", () => {
        player.pause();
      });
    }
  }

  // Owl Carousels defensively initialized via jQuery if loaded
  if (window.jQuery) {
    if (document.getElementById('three-post')) {
      window.jQuery('#three-post').owlCarousel({
        loop:true,
        nav: false,
        dots: true,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
          0:{
            items:1
          },
          600:{
            items:2
          },
          1000:{
            items:3
          }
        }
      });
    }

    if (document.getElementById('two-post')) {
      window.jQuery('#two-post').owlCarousel({
        loop:true,
        nav: false,
        dots: true,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        responsive:{
          0:{
            items:1
          },
          600:{
            items:1
          },
          1000:{
            items:2
          }
        }
      });
    }

    if (document.getElementById('single')) {
      window.jQuery('#single').owlCarousel({
        loop:true,
        nav: false,
        dots: true,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        items: 1,
      });
    }
  }
}

document.addEventListener("turbo:load", () => {
  if (document.querySelector("body.home-index, body.site-landingpage")) {
    console.log("site.js initialized");
    setup_site();

    // Intersection Observer for Scroll-Driven Reveal Animations
    const initScrollReveals = () => {
      const reveals = document.querySelectorAll('.reveal');
      if (!reveals.length) return;

      if (!window.IntersectionObserver) {
        reveals.forEach(el => el.classList.add('active'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('active');
              observer.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.05,
          rootMargin: "0px 0px -50px 0px"
        });

        reveals.forEach(el => observer.observe(el));
      }
    };

    // Parallax Background Movement for Hero Section
    const initHeroParallax = () => {
      const hero = document.querySelector('.hero-parallax');
      if (!hero) return;

      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        hero.style.backgroundPositionY = `calc(50% + (${scrollY * 0.15}px))`;
      });
    };

    initScrollReveals();
    initHeroParallax();
  }
});
